var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12"}},[_c('v-divider',{staticClass:"primary"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }